import React, { ReactNode } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgCloseButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { AlertColor } from "@mui/material/Alert/Alert";

import { useGetOrg } from "../../api/organizations/get-organization";
import {
  dismissAlert,
  getIsAlertDismissed,
} from "../../store/slices/appSettings";

import { ColorMap } from "./IgAlert";

interface IgInfoProps {
  dismissId: string;
  severity: AlertColor;
  title?: string;
  message?: string;
  buttons?: ReactNode[];
}

export const IgInfo = ({
  dismissId,
  severity,
  title,
  message,
  buttons,
}: IgInfoProps) => {
  const dispatch = useDispatch();
  const org = useGetOrg();
  const isDismissed = useSelector(
    getIsAlertDismissed(org.data?.org.id, dismissId)
  );

  if (isDismissed) {
    return null;
  }

  return (
    <Grid
      direction={"column"}
      container
      item
      sx={{
        border: `1px solid ${ColorMap[severity]}`,
        backgroundColor: "white",
        borderRadius: "8px",
        position: "fixed",
        bottom: "10px",
        left: "10px",
        paddingX: "25px",
        paddingY: "15px",
        width: "fit-content",
        zIndex: 2147483647,
      }}
      rowSpacing={1}
    >
      <Grid marginBottom={"10px"}>
        {title && (
          <Grid item marginBottom={"5px"}>
            <IgTypography fontWeight={500} color={ColorMap[severity]}>
              {title}
            </IgTypography>
          </Grid>
        )}
        {message && (
          <Grid item>
            <IgTypography>{message}</IgTypography>
          </Grid>
        )}
      </Grid>
      <Grid item container direction={"row"} columnSpacing={1.25}>
        {(buttons || []).map((button, index) => {
          return (
            <Grid item key={`alert-button-${index}`}>
              {button}
            </Grid>
          );
        })}
        {dismissId ? (
          <Grid item>
            <IgButton
              variant={"outlined"}
              onClick={() => {
                dispatch(
                  dismissAlert({ orgId: org.data.org.id, alertId: dismissId })
                );
              }}
            >
              Dismiss
            </IgButton>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
